import { render, staticRenderFns } from "./Stnk.vue?vue&type=template&id=4558b25c&"
import script from "./Stnk.vue?vue&type=script&lang=js&"
export * from "./Stnk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports